const amountFormat = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const quantityFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
});

const compactFormat = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

// 283103.47 -> "283,103.47"
export const formatAmount = (value: number | string) =>
  amountFormat.format(Number(value));

// 0.0833 -> "0.08", 127 -> "127", 0.003 -> "< 0.01" (not a misleading "0")
export const formatQuantity = (value: number) =>
  value > 0 && value < 0.01 ? "< 0.01" : quantityFormat.format(value);

// 26064.33 -> "26.1K"
export const formatCompact = (value: number) => compactFormat.format(value);

// "2026-09-21" -> "21/09/2026", the format used across the portal
export const formatIsoDate = (isoDate: string) => {
  const [year, month, day] = isoDate.split("-");
  return day && month && year ? `${day}/${month}/${year}` : isoDate;
};
